import '@/assets/styles/main.scss';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'moment/min/locales';

import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import '@/utils/localization/i18next';

import { BASENAME, IS_ADMIN } from '@/services/Constants';
import { initializeBugsnag } from '@/services/Helper';
import { componentLoader } from '@/componentLoader';
import { store } from '@/store';

import ConditionalWrapper from '@/components/ConditionalWrapper';

let App;
const RootElement = ReactDOM.createRoot(document.getElementById('root'));

async function startApp() {
	if (IS_ADMIN) {
		App = lazy(() => componentLoader(() => import('@/admin/AdminApp'), 3));
	} else {
		App = lazy(() => componentLoader(() => import('@/App'), 3));
	}

	const html = document.getElementsByTagName('html')[0];

	// To prevent rendertron from injecting base tag with its origin,
	// which will results in CORS issue on loading static (js/css) files.
	// https://github.com/GoogleChrome/rendertron/blob/7999fc591901e2038f4b664e5098e6d8589da177/src/renderer.ts#L72
	const head = html.getElementsByTagName('head')[0];
	const base = document.createElement('base');
	const port = window.location.port ? `:${window.location.port}` : '';
	const origin = `${window.location.protocol}//${window.location.hostname}${port}`;
	base.setAttribute('href', origin);
	head.append(base);

	window.addEventListener('keyboardDidShow', () => {
		html.classList.add('keyboard-on');
	});

	window.addEventListener('keyboardDidHide', () => {
		html.classList.remove('keyboard-on');
	});

	const ErrorBoundary = initializeBugsnag();

	RootElement.render(
		<ConditionalWrapper
			condition={ErrorBoundary}
			wrapper={(children) => <ErrorBoundary children={children} />}
		>
			<Provider store={store}>
				<BrowserRouter basename={BASENAME}>
					<Suspense fallback={<></>}>
						<App />
					</Suspense>
				</BrowserRouter>
			</Provider>
		</ConditionalWrapper>,
	);
}

startApp();
